import React, { useEffect } from 'react';
import { Keys, locale } from 'src/i18n';
import { useAppDispatch } from 'src/store/hooks';
import { navigate } from 'src/workspace/utils';
import { RedirectType } from '../enum';
import { setSelectedTileData, setTileActionError } from '../slice';
import { RedirectActionProps } from '../types';

function RedirectAction({
  widgetCode,
  action,
}: RedirectActionProps): React.ReactElement | null {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setSelectedTileData({ widgetCode, data: {} }));
    if (
      [RedirectType.INTERNAL_WEBLINK, RedirectType.EXTERNAL_WEBLINK].includes(
        action.redirect_type,
      )
    ) {
      if (action.redirect_type === RedirectType.EXTERNAL_WEBLINK) {
        window.open(action.uri, '_blank');
      } else {
        navigate(action.uri);
        window.location.href = action.uri;
      }
    } else if (
      [RedirectType.INTERNAL_DEEPLINK, RedirectType.EXTERNAL_DEEPLINK].includes(
        action.redirect_type,
      )
    ) {
      dispatch(
        setTileActionError({
          widgetCode,
          data: locale(Keys.INVALID_ACTION_REDIRECTION, {
            redirectType: action.redirect_type,
          }),
        }),
      );
    }
  }, [action, dispatch, widgetCode]);

  return null;
}

export default RedirectAction;
